import { ComponentProps, useCallback } from 'react';
import { Modal as RSModal } from 'reactstrap';
import { Content } from 'src/contexts/ContentContext';
import { GenericDialog } from 'src/core/interim/dialogs/GenericDialog';
import { useTagsForEntityType } from 'src/hooks/useTagsForEntityType';
import { ContentId } from 'src/utils/constants/contentId';
import { Tag } from 'src/WebApiController';

import { CreateTagMetadataFormProps } from '../TagsFormBody.types';
import { CreateTagMetadataForm } from './CreateTagMetadataForm';

export type CreateTagMetadataDialogProps = Pick<
  CreateTagMetadataFormProps,
  'entityType' | 'onClose'
> &
  ComponentProps<typeof RSModal>;

export function CreateTagMetadataDialog({
  onClose,
  onTagChange,
  entityType,
  ...rest
}: CreateTagMetadataDialogProps) {
  const {
    tagsMetadata: existingTagsCurrentType = [],
    mergeEntityTagsMetadata,
  } = useTagsForEntityType(entityType);

  const onTagMetadataUpdate = useCallback(
    async (tagMetadataUpdate: Tag) => {
      // Update tags metadata immediately
      await mergeEntityTagsMetadata([tagMetadataUpdate]);
    },
    [mergeEntityTagsMetadata]
  );

  return (
    <GenericDialog
      header={<Content id={ContentId.AddTag} />}
      footer={<></>}
      {...rest}
      size={'lg'}
      onCancel={onClose}
    >
      <CreateTagMetadataForm
        mergedTagsMetadata={existingTagsCurrentType ?? []}
        onSubmit={onTagMetadataUpdate}
        onClose={onClose}
        entityType={entityType}
        useDialogStyle
      />
    </GenericDialog>
  );
}
